<template>
  <div id="app">
    <div class="kt-banner">
      <span style="position: absolute;top: 150px;left:358px">
        <font color="#22aef8" style="font-size: 100px;letter-spacing:12pt;">控糖百科</font><br/>
        <font color="#22aef8" style="width:434px;height:33px;font-size:30px;font-family:MicrosoftYaHei;color:rgba(103,190,236,1);line-height:36px; ">Sugar Controlled Encyclopedia</font>
      </span>
    </div>
    <div style="background: #fff">
      <div class="box">
      	<hr style="position: absolute;margin: 62px 270px;width: 920px;height:1px;background-color:#D9D9D9;">
      	<div style="margin-left: 400px; width: 200px;height: 33px;"></div>
        <el-menu class="el-menu-demo box-nav" active-text-color="#00b9cd" mode="vertical" @select="handleSelect" :default-openeds="['0']">
          <el-submenu index="0">
           <!--  <template slot="title" ></template> -->
            <div style="width:214px;height:66px;background-color:#02C3D8;margin-top: -92px;box-shadow: 0px 0px 5px #e9ebeb;"><span style="line-height:65px;color:#FFF;font-size:22px;box-shadow: 0px 0px 5px #e9ebeb;">文章分类</span></div>
            <!--<el-menu-item index="0">全部</el-menu-item>-->
            <label v-for="(item,i) in tags"><el-menu-item :index="tags[i].id">{{tags[i].name}}</el-menu-item></label>
          </el-submenu>
        </el-menu>
        <a v-for="(item,i) in list" target="_blank" :href='""+host+"/html/news/detail-"+list[i].id+".html"' style="margin-left:270px;display: inherit;">
          <div class="introduction-lists">
            <img class="list-tus" :src='""+host+""+list[i].title_img+""'></img>
           <!-- <i class="list-tus" :style='"background: url("+host+"/"+list[i].title_img+") no-repeat center center;background-size:cover;"'></i>
            -->
            <p class="list-centBoxs">
              <span class="list-title">{{list[i].title}}</span>
              <span class="list-cent">{{list[i].add_time}}</span>
              <span class="list-cent">{{list[i].summary}}</span>
            </p>
          </div>
        </a>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="prev, pager, next, jumper" :total="total">
    </el-pagination>
        <!--<el-pagination @current-change ="handleCurrentChange"  background layout="prev, pager, next" :total="total"></el-pagination>-->
      </div>
      
    </div>

    <footerBottomer></footerBottomer>
      
      <!-- <div class="box1">
        <div class="boxEnd-1">
          <i class="logo1"></i>
          <p>400热线：400-836-5596<br/>客服电话：0755-27299992<br/>渠道合作：caoqifan@ttq.so<br/>官方微信：ttqcare<br/>地址：广东省深圳市宝安区西乡街道宝民二路IDT研发中心4层</p>
        </div>
        <div class="boxEnd-2">
          <span class="ewm1"><label class="wxb">官方微博</label></span>
          <span class="ewm2"><label class="wxb">官方微信</label></span>
          <i class="xian"></i>
            <span class="yptu">
            <label class="ypwz">雅培辅理善瞬感软件</label>
              <a class="mac" href="https://freestyleserver.com/distribution/fxaa20.aspx?product=fslibre&version=latest&os=mac&region=cn&language=xx_yy"></a>
              <a class="win" href="https://freestyleserver.com/distribution/fxaa20.aspx?product=fslibre&version=latest&os=win&region=cn&language=xx_yy"></a>
            </span>
        </div>
      </div>
      <div style="background: #f7f8fa">
        <div class="box-ends">
          Copyright @ 2014-2024 aibaowei.All Rights Reserved
          <label>爱宝惟生物科技有限公司版权所有</label>
          <a href="http://www.beian.miit.gov.cn">粤ICP备14072944号</a>
        </div>
      </div> -->
  </div>
</template>

<script>
  import footerBottomer from './footerBottomer.vue'
  export default {
    name: 'articelName',
    components: {
     footerBottomer
  	},
    data () {

      return {
        host: this.GLOBAL.host,
        total: 50,  // 记录总条数
        list:{},
        tags:[],
        page:0,
        tag_id:0,
      }
    },
    methods: {
      handleSizeChange(){
        
      },
      //获取当前页事件
      handleCurrentChange(val) {

        this.page=val;
        this.article(this.tag_id,this.page);
      },
      //导航选中事件
      handleSelect(vai){
        this.tag_id=vai;
        this.article(this.tag_id,this.page);
      },
      article(tag_id,page){
        this.$http.get(this.host +'/site/article.html?tag_id='+tag_id+'&page='+page+'').then((response) => {
          this.list=response.data.data.list;
          console.log(this.list)
          this.total=parseInt(''+response.data.data.page_info.page_total+'0');

        }, (response) => {});
      }
    },
    created: function () {
      this.article();
      this.$http.get(this.host+'/site/articleClassifyTag.html').then((response) => {
        this.tags=response.data.data;
      }, (response) => {});
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #app{margin-top: 90px}
  .kt-banner{margin: auto; position: relative; background: url("../../site/bannerx11.png") no-repeat center center;margin-top: -20px;height: 420px;min-width: 1200px;max-width: 1920px;}
  .box{width: 1200px;margin: 0 auto;text-align: center;padding-top:60px;padding-bottom: 60px;border-bottom: 1px solid #d9d9d9;}
  .box1{width: 1200px;margin: 0 auto;text-align: center;padding-top:60px;padding-bottom: 60px;}
  .box-nav{color: #333;font-size: 18px;cursor:pointer;}
  #triangle-down {width: 0;height: 0;border-left: 5px solid transparent;  border-right: 5px solid transparent;  border-top: 10px solid #999;margin-left: 5px}

  .list-tus{box-shadow: 5px 5px 5px #e3e3e3;width: 210px;height:210px;display: inline-block;margin-right: 20px;border-radius: 10px;position: absolute;top:0;left: 0}
  .list-title{font-size: 20px;margin-bottom: 25px}
  .list-cent{margin-top:8px; color: #999999;font-size: 14px;line-height: 30px; word-break:break-all;display:-webkit-box; -webkit-line-clamp:3; -webkit-box-orient:vertical; overflow:hidden;}
  .el-pagination{margin-top: 65px;margin-bottom: 64px;font-size: 16px;color:333333;}
/*  后期更新的内容*/
	.introduction-lists{ margin-top: 50px;cursor: pointer;position: relative}
	.box{
    width: 1200px;margin: 24px auto;text-align: center;
    padding-top: 1px;padding-bottom: 60px;
   -moz-box-shadow:0px 0px 5px #e9ebeb;/*firefox*/
   -webkit-box-shadow:0px 0px 5px #e9ebeb; /*webkit*/
   box-shadow: 0px 0px 5px #e9ebeb;
    padding-right: 38px;}
	.list-tus{margin-top: 16px; box-shadow: 5px 5px 5px #e3e3e3;width: 221px;height: 180px;display: inline-block;margin-right: 20px;border-radius: 10px;
	position: absolute;top: 0;left: 0}
	.list-centBoxs{margin-left: 262px;width: 628px;max-width: 1170px;height: 190px;
	display: inline-block;text-align: left;vertical-align: top;}
	.list-title{margin-top:24px; color: #333333;font-size: 22px;margin-bottom: 40px;}
	.list-title:hover{color:#00B9CD;}
	.el-submenu__title {width:213px; font-size: 14px;color: #303133;background-color: #02C3D8;transition: border-color .3s, background-color .3s, color .3s;box-sizing: border-box;border-bottom: 1px solid #E3E3E3; height: 56px;line-height: 56px;
	padding: 0 20px;position: relative;
	-webkit-box-sizing: border-box;cursor: pointer;white-space: nowrap;}
	.el-submenu .el-menu-item {width: 214px; height: 68px;line-height: 70px;padding: 0 45px;min-width: 200px;border-bottom: 1px solid #eeeeee;font-size: 18px;background-color: #fafafa}
	.el-submenu__title * { vertical-align: middle}
	.el-submenu__title i { color: #00B9CD}
	.el-submenu__title:hover {background-color: #02C3D8;}
	i, label{display: inline;}
	.el-menu {float: left;width:213px; border-right: 1px solid #fff;list-style: none;
	margin: 0;padding-left: 0;background-color: #fff;box-shadow: 0px 0px 5px #e9ebeb;}
	.btn-next{display: inherit;}
	.el-menu-item:focus,
	.el-menu-item:hover {outline: 0;background-color: #ffffff !important;}

  .el-submenu .el-menu-item {width: 213px;height: 68px;line-height: 70px;
  padding: 0 45px;min-width: 200px;border-bottom: 1px solid #e3e3e3;font-size: 18px;}


</style>
<style>
	.el-pagination.is-background .btn-next,
	.el-pagination.is-background .btn-prev,
	.el-pagination.is-background .el-pager li{line-height: 42px;width: 41px;height: 41px; margin: 0 5px;background-color: #f4f4f5;font-size: 16px;color:#333333;min-width: 30px;
		border-radius: 2px;border: 1px solid #dcdcdc;}
		.el-pager li{line-height: 44px; height: 46px; width: 50px;border: 1px solid #e3e3e3;font-size: 16px;margin-left:10px;}
    .el-pagination .btn-next,.el-pagination .btn-prev {height:0px; background: 50% no-repeat #fff;
  background-size: 16px;cursor: pointer;margin: 0; color: #303133}
 	.el-pagination.is-background .el-pager li:hover {color:inherit;}
  .el-pager li.active{color: #00B9CD;cursor: default}
	.el-pagination.is-background .el-pager li.active {background-color:#00B9CD;color: #fff;}
	.el-pager li.active+li {border-left:1px solid #e3e3e3;}
	.el-pager li:hover {color: #FFF;background-color:#02C3D8;}
	.el-pager .more:before {line-height: 40px;}
  .el-pagination .btn-next,
  .el-pagination .btn-prev { height: 46px;background: 50% no-repeat #fff;background-size: 16px;cursor: pointer; margin: 0;color: #303133
  }
	.el-pagination .btn-next .el-icon,
	.el-pagination .btn-prev .el-icon {margin-left: 10px;line-height: 43px;display: block;font-size: 16px;font-weight: 700;
    width: 38px;border: 1px solid #dcdcdc;}
  .box a{width: 2px;}
	.el-pagination__jump {margin-left: 24px;margin-top: 7px;font-weight: 400;color: #606266;}

</style>



// WEBPACK FOOTER //
// content.vue?10136187